import { useState } from 'react'

export const useLocalStorage = (key = '', initialValue = '') => {
    const [state, setState] = useState(() => {
        try {
            const item = window.localStorage.getItem(key)
            return item ? JSON.parse(item) : initialValue
        } catch (error) {
            return initialValue
        }
    })

    const setLocalStorageState = newState => {
        try {
            const newStateValue = typeof newState === 'function' ? newState(state) : newState
            setState(newStateValue)
            window.localStorage.setItem(key, JSON.stringify(newStateValue))
        } catch (error) {
            throw error
        }
    }

    const removeLocalStorageState = () => {
        try {
            window.localStorage.removeItem(key)
        } catch (error) {
            throw error
        }
    }

    return [state, setLocalStorageState, removeLocalStorageState]
}
